export default __webpack_public_path__ + "static/Witcher-74fbf83e1d8352615af75b89cd3dfb24.png";